var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        {
          staticClass: "my-select",
          class: { "is-focus": _vm.isOpen, "has-value": _vm.hasValue }
        },
        [
          _c("multiselect", {
            ref: "select",
            class: _vm.additionalClass,
            attrs: {
              options: _vm.options,
              name: _vm.name,
              "track-by": _vm.trackBy,
              label: _vm.label,
              searchable: _vm.searchable,
              multiple: _vm.multiple,
              disabled: _vm.disabled,
              "show-labels": _vm.showLabels,
              "allow-empty": _vm.allowEmpty,
              "custom-label": _vm.customLabel,
              "group-values": _vm.groupValues,
              "group-label": _vm.groupLabel,
              "group-select": false,
              "clear-on-select": _vm.clearOnSelect,
              "close-on-select": _vm.closeOnSelect
            },
            on: { open: _vm.onFocus, close: _vm.onBlur, input: _vm.onInput },
            scopedSlots: _vm._u(
              [
                {
                  key: "option",
                  fn: function(props) {
                    return props.option.name
                      ? [
                          _c("span", { class: props.option.class }, [
                            _vm._v(_vm._s(props.option.name))
                          ])
                        ]
                      : undefined
                  }
                },
                {
                  key: "noOptions",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("capitalize")(_vm.lang.no_value)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "selection",
                  fn: function(ref) {
                    var values = ref.values
                    var search = ref.search
                    var isOpen = ref.isOpen
                    return _vm.multiple
                      ? [
                          _vm.current_value && _vm.current_value.length > 1
                            ? _c(
                                "span",
                                { staticClass: "multiselect__single" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.current_value.length) +
                                      " " +
                                      _vm._s(_vm.customMultiselectLabel)
                                  )
                                ]
                              )
                            : _vm.current_value && _vm.current_value.length
                            ? _c(
                                "span",
                                { staticClass: "multiselect__single" },
                                [_vm._v(_vm._s(_vm.current_value[0].name))]
                              )
                            : _vm._e()
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.current_value,
              callback: function($$v) {
                _vm.current_value = $$v
              },
              expression: "current_value"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "my-select-label",
              class: { "network-color": _vm.isOpen },
              on: {
                click: function($event) {
                  return _vm.$refs.select.activate()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.placeholder)) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.clearable && _vm.hasValue
            ? [
                _c(
                  "button",
                  {
                    staticClass: "clearable",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.clearInput.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/clear-search.svg",
                        alt: "Reset"
                      }
                    })
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }